import { createRootRoute, Outlet, Link } from "@tanstack/react-router"
import CustomAppBar from "@/components/navigation/CustomAppBar"
import { Footer } from "@/components/navigation/Footer"
import { Button } from "@/components/ui/button"

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
})

function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <CustomAppBar />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

function NotFound() {
  return (
    <div className="flex justify-center items-center flex-col flex-1 gap-4">
      <h1 className="font-serif font-bold text-6xl">404</h1>
      <p className="text-lg text-muted-foreground">
        Diese Seite wurde nicht gefunden
      </p>
      <Button asChild>
        <Link to="/">Hier gehts zurück</Link>
      </Button>
    </div>
  )
}
